import { createSlice } from '@reduxjs/toolkit';
import { Activity, ActivityState, ApiActivity } from '../../app/types';

const initialState: ActivityState = {
    activitiesByWeek: {},
    activityIndex: {},
    createdActivityId: null,
    createPlanDateTime: "",
    createdActivityGuid: '',
    acceptedActivityId: null,
    selectedDateForActivityCreate: '',
    selectedHourForActivityCreate: ''
}
const activitySlice = createSlice({
    name: 'activity',
    initialState,
    reducers: {
        setActivities(state: ActivityState, action: { payload: { key: string, activities: ApiActivity[]} }) {
            let { activities, key } = action.payload;
            if (!state.activitiesByWeek) state.activitiesByWeek = {};
            if (!state.activityIndex) state.activityIndex = {};
            // burada array formunda gelen statement listesini
            // map'e donusturuyoruz. surekli bu elemanlara erismemiz gerekecek
            // array icinde bulmaya calismak liste boyutu arttikca performans
            // sorunlarina neden olacaktir.
            if (state.activitiesByWeek[key] !== undefined && state.activitiesByWeek[key].length > 0 ) {
                const newItem = activities.filter((f) => { return !state.activitiesByWeek[key].includes(f.guid) }).map((m) => m.guid);// Var olanları tekrar eklemesin..
                state.activitiesByWeek[key] = [...state.activitiesByWeek[key], ...newItem];
            } else {
                state.activitiesByWeek[key] = [...activities.map(a => a.guid)];
            }
            activities.forEach((api_activity) => {
                let client_activity: Activity = { ...api_activity, activityStatementIndex: {} };
                delete (client_activity as any).activityStatements;
                delete (client_activity as any).__typename;
                if (api_activity.activityStatements) {
                    api_activity.activityStatements.forEach((st: any) => {
                        client_activity.activityStatementIndex[st.activityStatementId] = st;
                    });
                }
                state.activityIndex[client_activity.guid] = client_activity;
            });
         },
        // updateActivityStatus(state: ActivityState, action: { payload: { activityGuid: string, status: ActivityStatus, updateVersion: [] } }) {
        //     let { activityGuid, status, updateVersion } = action.payload;
        //     state.activityIndex[activityGuid].activityStatus = status;
        //     state.activityIndex[activityGuid].activityStatusId = status.activityStatusId;
        //     state.activityIndex[activityGuid].updateVersion = updateVersion;
        // },
        // setUpdateActivityStatement(state: ActivityState, action: { payload: ModelOfStateUpdateStatement }) {
        //     let myActivity: any;
        //     myActivity = state.activityIndex[action.payload.activityGuid]
        //     let newElementActivity = myActivity as Activity
        //     console.log('newElementActivity', newElementActivity.activityStatementIndex);
        //     let getElement = state.activityIndex[newElementActivity.guid].activityStatementIndex[action.payload.activityStatementId]
        //     console.log('getElement', getElement);
        //     getElement.value = action.payload.value
        //     getElement.notes = action.payload.note
        //     console.log('action.payload.note',
        //     action.payload.note);
        //     getElement.updateVersion = action.payload.updateVersion
        //     state.activityIndex[newElementActivity.guid].activityStatementIndex[action.payload.activityStatementId] = getElement
        // },
        // deleteActivities(state: ActivityState) {
        //     state.activitiesByWeek = {};
        //     state.activityIndex = {};
        //     state.createdActivityId = null;
        //     state.createdActivityId = "";
        //     state.createPlanDateTime = "";
        //     state.acceptedActivityId = null;
        // },
    }
});
export const {
    // setUpdateActivityStatement,
    // pushActivityStatementDocument,
    // spliceActivityStatementDocument,
    // checkAndSetActivityDocumentsExists,
    // setActivityStatementDocumentIsExists,
    // checkAndSetActivityStatementDocumentExsists,
     setActivities,
    // updateActivityStatus,
    // setAcceptedActivityId,
    // deleteActivities
} = activitySlice.actions;
export default activitySlice.reducer;